import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './navigation.css';

const Navigation = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    const navItems = [
        { id: 1, label: 'Home', path: '/' },
        { id: 2, label: 'Blog', path: '/blog' },
        { id: 3, label: 'Projects', path: '/projects' },
        { id: 4, label: 'Photography', path: '/photography' },
        { id: 5, label: 'Profile', path: '/profile' },
        { id: 6, label: 'Contact', path: '/contact' },
    ];

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    // Effect to close the menu if the screen width goes above 600px
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 600) {
                closeMenu(); // Close the menu if the screen width is greater than 600px
            }
        };
        window.addEventListener('resize', handleResize);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="navbar-container">
            <nav className="topnav">
                <div className="menu-icon" onClick={toggleMenu}>
                    <p>&#9776;</p>
                </div>
                <ul className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
                    {isMenuOpen && (
                        <li className="close-icon" onClick={closeMenu}>
                            <p>&times;</p>
                        </li>
                    )}

                    {navItems.map((item) => (
                        <li key={item.id}>
                            <Link
                                className={
                                    (item.path === '/' && location.pathname === '/') ||
                                    (item.path !== '/' && location.pathname.startsWith(item.path))
                                        ? 'active'
                                        : ''
                                }
                                to={item.path}
                                onClick={closeMenu}
                            >
                                {item.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
};

export default Navigation;
